<div class="modal-body">
  <div class="container text-center py-4">
    <div class="row justify-content-center">
      <div class="col-10 col-md-8 col-lg-8">
        <!-- Icon -->
        <div class="icon-container mb-4">
          <svg width="148" height="117" viewBox="0 0 148 117" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.2"
              d="M128.381 19.7861C142.147 37.1621 143.664 68.0657 130.598 88.5904C117.649 108.998 90.1168 118.911 66.3182 116.695C42.5196 114.596 22.3374 100.369 12.538 81.8266C2.73859 63.2844 3.32189 40.4274 13.3546 25.1505C23.3874 9.87363 42.9862 2.2935 65.8516 0.427627C88.6002 -1.43825 114.615 2.41012 128.381 19.7861Z"
              fill="#FDB927" />
            <circle opacity="0.5" cx="143.55" cy="86.8501" r="4.05" fill="#FDB927" />
            <circle opacity="0.5" cx="8.6" cy="103.5" r="8.1" fill="#FDB927" />
            <circle opacity="0.5" cx="10.8492" cy="11.2501" r="3.15" fill="#FDB927" />
            <path
              d="M114.891 29.3156C125.331 42.4144 126.481 65.711 116.572 81.1834C106.751 96.5679 85.8717 104.04 67.8231 102.37C49.7745 100.788 34.4686 90.0625 27.0368 76.0845C19.605 62.1066 20.0474 44.8759 27.6561 33.3595C35.2648 21.8431 50.1284 16.1289 67.4692 14.7223C84.7215 13.3157 104.451 16.2168 114.891 29.3156Z"
              fill="#FDB927" />
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M91.9004 58.4999C91.9004 68.9381 83.4386 77.3999 73.0004 77.3999C62.5622 77.3999 54.1004 68.9381 54.1004 58.4999C54.1004 48.0617 62.5622 39.5999 73.0004 39.5999C83.4386 39.5999 91.9004 48.0617 91.9004 58.4999ZM94.6004 58.4999C94.6004 70.4293 84.9297 80.0999 73.0004 80.0999C61.071 80.0999 51.4004 70.4293 51.4004 58.4999C51.4004 46.5706 61.071 36.8999 73.0004 36.8999C84.9297 36.8999 94.6004 46.5706 94.6004 58.4999ZM83.3881 53.1711C83.9245 52.6532 83.9395 51.7985 83.4216 51.2622C82.9037 50.7258 82.0491 50.7108 81.5127 51.2287L69.417 62.9073L64.955 58.4453C64.4278 57.9181 63.573 57.9181 63.0458 58.4453C62.5186 58.9725 62.5186 59.8273 63.0458 60.3545L67.8205 65.1291C68.6883 65.9969 70.0914 66.0093 70.9743 65.1568L83.3881 53.1711Z"
              fill="white" />
          </svg>
        </div>
        <!-- Content -->
        <h2 class="modal-body__title fw-bold text-warning">{{title}}</h2>
        <p class="modal-body__text text-muted fs-6">
          {{bodyText}}
        </p>
      </div>
    </div>
  </div>
</div>
@if (title !== session) {
<div class="modal-footer justify-content-center gap-3">
  <button (click)="onLogout()" class="btn btn-outline-secondary ">
    No
  </button>
  <button (click)="onExtendSession()" class="btn btn-warning text-white">
    yes
  </button>
</div>
}
@else {
<div class="modal-footer justify-content-center gap-3">
  <button (click)="onExtendSession()" class="btn btn-warning text-white">
    login
  </button>
</div>
}